import { useServices } from "contexts/ServiceContext";
import { EventEnum } from "enums/EventEnum";
import useWindowOpenWithAnalytics from "hooks/useWindowOpenWithAnalytics";
import dynamic from "next/dynamic";
import React, { FC, useCallback } from "react";
import styled from "styled-components";
import useTranslation from "translations/useTranslation";
import CookiesPolicy from "./CookiePolicy";
import HelpSection from "./HelpSection";
import HelpSectionDouble from "./HelpSectionDouble";
import Layout from "./Layout";
import PrivacyManagement from "./PrivacyManagement";
import useConfigs from "hooks/useConfigs";

const ContactUsModal = dynamic(() => import("./ContactUsModal/ContactUsModal"), {
    ssr: false,
});

const StyledPageTitle = styled.h1`
    font-size: ${(props) => props.theme.typography.heading.big.fontSize};
    line-height: ${(props) => props.theme.typography.heading.big.lineHeight};
    font-weight: ${(props) => props.theme.typography.heading.big.fontWeight};
    color: ${(props) => props.theme.colors.neutral.neutral800};
    margin-bottom: ${(props) => props.theme.spacing.lg};
`;

const HelpContainer: FC<{}> = () => {
    const services = useServices();
    const { path_privacy_legal, path_terms_conditions } = useConfigs();
    const t = useTranslation();

    const goToLegalAdvertisement = useWindowOpenWithAnalytics(
        path_privacy_legal,
        EventEnum.LegalNotice,
    );

    const goToTermsAndConditions = useWindowOpenWithAnalytics(
        path_terms_conditions,
        EventEnum.TermsAndConditions,
    );

    const shopfullyContactUrl = "https://shopfully.com/contact/";

    const goToShopfullyContactForm = useWindowOpenWithAnalytics(
        shopfullyContactUrl,
        EventEnum.ShopfullyContact,
    );

    return (
        <Layout>
            <ContactUsModal />
            <StyledPageTitle>{t("HELP")}</StyledPageTitle>
            <CookiesPolicy />
            <HelpSection
                buttonText={t("CONTACT_BTN_TEXT")}
                paragraphText={t("CONTACT_US_PARAGRAPH")}
                titleText={t("CONTACT_US")}
                onButtonClick={goToShopfullyContactForm}
            />
            <HelpSectionDouble
                buttonText={t("PRIVACY_POLICY")}
                paragraphText={t("LEGAL_ADVERTISEMENT_PARAGRAPH")}
                titleText={t("LEGAL_ADVERTISEMENT")}
                onButtonClick={goToLegalAdvertisement}
                secondButtonText={t("TERMS_CONDITIONS")}
                onSecondButtonClick={goToTermsAndConditions}
            />
            <PrivacyManagement />
        </Layout>
    );
};
export default HelpContainer;
